// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/search/search.component.scss
// module id = 488
// module chunks = 0